import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import GoogleMapReact from 'google-map-react';
import './map.css';
import Pin from './pin';
import gJSON from './munic.json'
import Apply from './apply';
import InfoText from './infoText';
import Legend from './legend';
import Search from './search';
import { mapStyles } from './mapStyle';

const mapOptions = {
  styles: mapStyles
}

const Map = () => {

  const data = useStaticQuery(graphql`
query {
    contentfulMapInfo {
      id
      title
      mapInfoText {
        mapInfoText
      }
      mapQuote
      files {
        file {
          fileName
          url
        }
      }
    }
    contentfulMapMailSubjects {
      subjects
    }
    allContentfulMapRegions {
      edges {
        node {
          actionPlan
          citizensProposal
          regionName
          volunteers
        }
      }
    }
  }
`);

  const regions = data.allContentfulMapRegions.edges;
  let mailSubjects =  data.contentfulMapMailSubjects.subjects;
  mailSubjects = mailSubjects.split(",");

  let mobile;

  if (typeof window !== `undefined`) {
    mobile = window.innerWidth < 480 ? true : false;
  }
  const [selected, setSelected] = useState('');
  const [fieldRegion, setFieldRegion] = useState('');
  const [searchPopUp, setSearchPopUp] = useState(false);
  const [searchName, setSearchName] = useState('');
  const [apply, setApply] = useState(false);

  const defaultValues = {
    center: {
      lat: 62.812022147,
      lng: 15.581594364
    },
    zoom: 5,
  }

  const mouseInToRegion = (e) => {
    let name = e.feature.getProperty('NAME_2');
    fieldRegion !== name ? setFieldRegion(name) : setFieldRegion('');
  }

  const mouseOutOfRegion = () => {
    setFieldRegion("");
  }

  const handleApiLoaded = (map) => {
    let geoJson = '/municipalities.json';
    map.data.loadGeoJson(geoJson, { idPropertyName: 'NAME_2' });
    map.data.setStyle(StyleFeature);

    gJSON.features.forEach(function (municipality) {
      let averageLat = 0;
      let averageLong = 0;
      let totalNumberOfPoints = 0;
      
      const regionFoundIndex = regions.findIndex(function (region) {
        return region.node.regionName === municipality.properties.NAME_2;
      })
      if (regionFoundIndex > -1) {
        municipality.geometry.coordinates.forEach(function (_region) {
       
          /**
           * When regions have islands they are structured slightly differently so we cast a one length array up one step.
           */

          if (_region.length === 1) {
            _region = _region[0];
          }
          _region.forEach(function (coords) {
            totalNumberOfPoints++;
            averageLong += Number(coords[0]);
            averageLat += Number(coords[1]);
          })
        })
        averageLat = averageLat / totalNumberOfPoints;
        averageLong = averageLong / totalNumberOfPoints;

        regions[regionFoundIndex].node.lat = averageLat;
        regions[regionFoundIndex].node.long = averageLong;
        if (regions[regionFoundIndex].node.regionName === 'Krokom') {
          regions[regionFoundIndex].node.lat = 63.3258867;
          regions[regionFoundIndex].node.long = 14.4494415;
        }
      }
    });

    setSelected('done');

    map.data.addListener('mouseover', mouseInToRegion);
    map.data.addListener('mouseout', mouseOutOfRegion);
    let height;
    if (typeof window !== `undefined`) {
      const sendPostMessage = () => {
        if (height !== document.getElementById('map-wrapper').offsetHeight) {
          height = document.getElementById('map-wrapper').offsetHeight;
          window.parent.postMessage({
            frameHeight: height
          }, '*');
        }
      }

      window.onload = () => sendPostMessage();
      window.onresize = () => sendPostMessage();
    };
  };

  const StyleFeature = (feature) => {
    let colorReg = '#efefef';
    const nameR = feature.getProperty('NAME_2');

    regions.filter(reg => {
      return reg.node.actionPlan && nameR === reg.node.regionName && (colorReg = 'rgb(30, 169, 62)');
    });
    return ({
      strokeWeight: 0.5,
      strokeColor: 'gray',
      zIndex: 1,
      fillColor: colorReg,
      fillOpacity: 0.3,
      visible: true,
    });
  };

  const getAllregions = (name) => {
    let all = regions.map((region, index) => {      
      if (region.node.lat && region.node.long) {
        return (
          <Pin
            key={`${region.node.regionName}${index}`}
            name={region.node.regionName}
            lat={region.node.lat}
            lng={region.node.long}
            volonteers={region.node.volunteers}
            actionplan={region.node.actionPlan}
            citizensProposal={region.node.citizensProposal}
            id={region.node.regionName}
            fieldRegion={name}
            mobile={mobile}
            searchPopUp={searchPopUp}
            setSearchPopUp={setSearchPopUp}
            searchName={searchName}
            setSearchName={setSearchName}
            setApply={setApply}
            selected={selected}
          />
        );
      }
      else {
        return null;
      }
    }
    );
    return all;
  }

  return (
    <div id='map-wrapper' className={apply ? 'map-wrapper-fixed' : 'map-wrapper'} >
      <div className="map">
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.GATSBY_MAP_KEY }}
          defaultCenter={defaultValues.center}
          defaultZoom={defaultValues.zoom}
          yesIWantToUseGoogleMapApiInternals={true}
          onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
          options={mapOptions}
        >
          {getAllregions()}
          {fieldRegion && getAllregions(fieldRegion)}
          {searchPopUp && searchName && getAllregions()}
        </GoogleMapReact>
        <Search 
          setSearchPopUp={setSearchPopUp} 
          regions={regions} 
          setSearchName={setSearchName} 
          searchName={searchName}
        />
        <Legend/>
      </div>
      <div className='map-info-container'>
      <InfoText 
        title={data.contentfulMapInfo.title} 
        infoText={data.contentfulMapInfo.mapInfoText.mapInfoText} 
        quote={data.contentfulMapInfo.mapQuote}
        files={data.contentfulMapInfo.files}
        />
        </div>
        {apply && 
          <Apply 
            regions={regions} 
            searchName={searchName} 
            setApply={setApply}
            setSearchName={setSearchName}
            mailSubjects={mailSubjects}
          />
        }
    </div>
  );
}

export default Map;
